import React from 'react'
import Modal from 'react-modal'
import styles from './modalDialog.scss'
import stylesParent from './emailSetup.scss'
import cs from 'classnames'
import i18n from 'lib/i18n'

const _ = i18n('office')

const customStyles = {
	overlay: {
		position: 'fixed',
		top: 0, left: 0, right: 0, bottom: 0,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(255, 255, 255, 0.75)',
	},
	content: {
		position: 'relative',
        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
        maxHeight: '90%',
		overflow: 'auto',
        padding: '0',
        wordwrap: "break-word"
	},
}

/**
 * Simple are you sure modal, for general use in office module.
 */
export default class AreYouSureDialog extends React.Component {
	static propTypes = {
        modalIsOpen: React.PropTypes.bool,
        onCancel: React.PropTypes.func,
        onConfirmation: React.PropTypes.func,
        title: React.PropTypes.string,
        message: React.PropTypes.string,
        cancelLabel: React.PropTypes.string,
        confirmationLabel: React.PropTypes.string
    }

    constructor(props) {
        super(props)
		this.state = {}
    }

	render() {
        const {modalIsOpen, onCancel, onConfirmation, cancelLabel, confirmationLabel, title, message} = this.props

		return (
            <div>
				<Modal
                    isOpen={modalIsOpen}
                    onCancel={onCancel}
                    style={customStyles}
                    className={styles.modal}
                    contentLabel={""}
                >
                    <div>
                        <div className={styles.title}>
                            {title}
                        </div>
                        <div className={styles.contentWrapper}>
                            <div className={cs(stylesParent.formContent, styles.content)}>
                            <div className={stylesParent.formInputContainer}>
                                <label className={cs(stylesParent.formLabel, stylesParent.sizeS)}>
                                    {message}
                                </label>
                            </div>
                            </div>
                            <div className={styles.buttons}>
                                <div
                                    onClick={() => {
                                        // close modal
                                        return onCancel()
                                    }
                                    }
                                    className={(styles.cancel)}
                                >
                                    {cancelLabel}
                                </div>
                                <div
                                    onClick={() => {
                                        return onConfirmation()
                                    }}
                                    className={cs(styles.next, styles.enabled)}
                                >
                                    {confirmationLabel}
                                </div>
                            </div>
                        </div>
                    </div>

                </Modal>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/office/areYouSureModal.jsx